import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20manga%20illustration%20with%20colorful%20comic%20book%20elements%20floating%20in%20dynamic%20composition%2C%20warm%20orange%20and%20coral%20gradient%20background%20with%20subtle%20paper%20texture%2C%20manga%20panels%20and%20speech%20bubbles%20as%20decorative%20elements%2C%20modern%20flat%20illustration%20style%2C%20energetic%20and%20inviting%20atmosphere&width=1800&height=900&seq=hero-bg-jmcomic-01&orientation=landscape"
          alt="禁漫天堂 JMComic 漫画阅读平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50/90 font-medium">2026年最新官方入口已更新</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
          禁漫天堂 JMComic
          <br />
          <span className="text-primary-300">官方入口与使用指南</span>
        </h1>

        <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          禁漫天堂 JMComic 是深受用户喜爱的漫画阅读平台。本页为您提供最新访问地址、注册登录方法、
          内容分类导览及常见问题解答，帮助您快速找到并顺畅使用禁漫天堂的全部功能。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={`https://${siteInfo.latestAddress}`}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            <i className="ri-external-link-line text-lg"></i>
            立即访问官网
          </a>
          <a
            href="#latest-address"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            <i className="ri-link text-lg"></i>
            查看最新地址
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 flex-wrap">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{siteInfo.totalUsers}</div>
            <div className="text-xs text-background-300/70 mt-1">累计用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{siteInfo.totalComics}</div>
            <div className="text-xs text-background-300/70 mt-1">漫画资源</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{siteInfo.dailyUpdate}</div>
            <div className="text-xs text-background-300/70 mt-1">每日更新</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}